// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__14ddM","item":"PaymentsMobile_item__9gXIp","label":"PaymentsMobile_label__2X_q-","amount":"PaymentsMobile_amount__1tgCh"};